export const showShortName = (fullName: string) => {
  if (!fullName) {
    return '';
  }

  return fullName.split(' ').map((word) => word[0]?.toUpperCase());
};
